import React from 'react';
import ReactDOM from 'react-dom';
import SloganSection from '../components/SloganSection';
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderSloganSection = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {
    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<SloganSection props={props} />, element);
      })
      .catch(error => {
        //console.error("Failed to initialize i18n before rendering SloganSection:", error);
      });
  }
};
